/**
* @Author: zhangxiaojian
* @Date: 2025/7/15
* @LastEditors: zhangxiaojian
* @Description 国密sm4加密解密，封装成类
**/


import * as smCrypto from 'sm-crypto'
export default class SM4 {
  // sm4加密秘钥
  constructor(key) {
    if(!key){
      // 获取登录时的公钥，截取32位作为key
      let loginInfo  = localStorage.getItem('loginInfo')
      loginInfo = JSON.parse(loginInfo)
      let pubKey = (loginInfo?.userCode || "") + loginInfo?.userID
      if(!pubKey){
        // 登录时公钥不存在或被删除，需要重新登录
        localStorage.removeItem('loginInfo')
        localStorage.removeItem('rrLoginUserInfo')
        location.href = '/login'
      }else if(pubKey.length !== 32){
        // 密钥长度不足32位，填充固定串
        const pubKeyPadding = "7A9C98341EDB4E07A8AAFB7935D6CBCE"
        pubKey = (pubKey + pubKeyPadding).slice(0,32)
      }
      key = pubKey
    }
    if(!key){
      throw new Error('sm4 key is empty')
    }
    this.encrptyKey = key || "";
  }

  /**
   * 用于加密数据
   * @param {any} msgString - 需加密的数据
   * @return {string} 加密后的字符串
   */
  encrypt(msgString) {
    let msg = msgString
    if (typeof msgString !== 'string') {
      msg = JSON.stringify(msgString)
    }
    let sm4 = smCrypto.sm4

    // 1 - C1C3C2； 0 - C1C2C3； 默认为1
    let cipherMode = 0 // 特别注意,此处前后端需保持一致
    // 加密结果
    let encryptData = sm4.encrypt(msg, this.encrptyKey, cipherMode)
    // 加密后的密文前需要添加04，后端才能正常解密
    return '04' + encryptData
  }

  /**
   * 用于解密数据
   * @param {any} enStr - 待解密的数据
   * @return {string} 解密后的字符串
   */
  decrypt(enStr) {
    let msg = enStr
    if (typeof enStr !== 'string') {
      msg = JSON.stringify(enStr)
    }
    let sm4 = smCrypto.sm4
    // 1 - C1C3C2； 0 - C1C2C3； 默认为1
    let cipherMode = 0
    // 加密后的密文，需要前去掉04。因为doDecrypt中自行添加了04，后端加密代码也自行添加了04
    let en = msg.substr(2)
    // 解密结果
    return sm4.decrypt(en, this.encrptyKey, cipherMode)
  }
}
